import React from 'react';
const OverViewTableComponent = ({ dataSource, columns, showNoDateData, onClickView }) => {
	function createRows(data,index) {
		const stledobj = {};
		if (data.status === 'delivered' || data.status === 'done') {
			stledobj.opacity = '0.4000000059604645';
		}
		
		return (
			<tr style={stledobj}>
				{columns.map((col, index) => {
					if (col.renderis) {
						return <td>{col.renderis(data)}</td>;
					}
					return <td>{data[col.dataIndex]}</td>;
				})}
			</tr>
		);
	}

	return (
		<div
			className="OverviewTable"
			style={{ overflowX: 'auto', position: 'relative', maxWidth: 'inherit' }}
		>
			<table style={{ width: '100%', overflowY: 'auto' }}>
				<thead>
					<tr style={{borderTop:"none"}}>
						{columns?.map((ele) => (
							<td>{ele.title}</td>
						))}
					</tr>
				</thead>
				<tbody>{dataSource.map((data,index) => createRows(data,index))}</tbody>
			</table>
		</div>
	);
};

export default OverViewTableComponent;
